import { useMemo } from "react";
import { useCryptocurrenciesQuery } from "web_myplann/Api/Portfolio/Queries/useCryptocurrenciesQuery";
import type { FlatRowSelectOption } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

export const useCryptocurrencyOptions = (): FlatRowSelectOption<string>[] => {
	const { data } = useCryptocurrenciesQuery();

	return useMemo(
		() =>
			(data?.data ?? []).map((cryptocurrency) => ({
				value: cryptocurrency.id,
				label: cryptocurrency.name,
			})),
		[data],
	);
};
